import { defineStore } from 'pinia'
import { ref, computed } from "vue";

export const useVideoModalControlsStore = defineStore('VideoModalControls', () => {

    // State
    const modalShow  = ref(false),
          modalEmbed = ref(null),
          modalTitle = ref(null)

    // Getters
    const modalVisible = computed(() => { return modalShow.value })

    // Actions
    function modalOpen(url) {
        modalEmbed.value = url
        setTimeout(() => {
            modalShow.value = true
        }, 100)
    }

    function modalClose() {
        modalShow.value = false
        setTimeout(() => {
            modalEmbed.value = null
            if (modalTitle.value) {
                modalClearTitle()
            }
        }, 500)
    }

    function modalSetTitle(title) {
        modalTitle.value = title
    }

    function modalClearTitle() {
        modalTitle.value = null
    }

    return {
        modalShow,
        modalEmbed,
        modalTitle,
        modalVisible,
        modalOpen,
        modalClose,
        modalSetTitle,
        modalClearTitle
    }
})
